module.exports = __webpack_public_path__ + "img/workout-notebook_B095QCJB34.658ac81d.jpg";